import React from "react";
import {
    DataGridPremium,
    gridClasses,
    useGridApiRef,
    useKeepGroupedColumnsHidden,
} from "@mui/x-data-grid-premium";
import { styled, alpha } from "@mui/material/styles";
import { Box } from "@mui/material";
import { LicenseInfo } from "@mui/x-license";

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGridPremium)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover': {
                // backgroundColor: alpha(
                //     theme.palette.primary.main,
                //     ODD_OPACITY +
                //     theme.palette.action.selectedOpacity +
                //     theme.palette.action.hoverOpacity,
                // ),
                // '@media (hover: none)': {
                //     backgroundColor: alpha(
                //         theme.palette.primary.main,
                //         ODD_OPACITY + theme.palette.action.selectedOpacity,
                //     ),
                // },
            },
        },
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },

    "& .MuiDataGrid-cell": {
        paddingTop: "5px !important",
    },
    "& .MuiDataGrid-columnHeader": {
        backgroundColor: "#0A2240",
        color: "#fff !important",
    },
    "& .MuiDataGrid-sortIcon, .MuiDataGrid-filterIcon .MuiDataGrid-menuIcon": {
        color: "#0A2240 !important",
    },
    "& .MuiDataGrid-columnHeader:hover .MuiDataGrid-menuIcon": {
        color: "#0A2240 !important",
    },

    // Toolbar icons in red
    "& .MuiDataGrid-toolbarContainer .MuiButtonBase-root": {
        color: "red",
    },
    // total row style
    '& .MuiDataGrid-pinnedRows--bottom .MuiDataGrid-row.total-row': {
        backgroundColor: '#FFE9B3 !important',
        fontWeight: "700 !important",
    },
}));

const MuiDataGrid = ({
    columns,
    rows,
    pagination,
    density,
    datagridName,
    isEdit,
    showToolbar,
    label,
    slots,
    pinnedRows,
    getRowClassName: externalGetRowClassName,
    sx: externalSx,
}) => {
    LicenseInfo.setLicenseKey(
        "7b2a7be60c5eff8e15f1f2ae43e1260dTz0xMjMyNTksRT0xNzk3NDY1NTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y"
    );
    // LicenseInfo.setLicenseKey(
    //   "25f2175523aa72e9d954ec0ef5a74461Tz05NjQ3MCxFPTE3NTU3MDU1NjQwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
    // );

    const customApiRef = useGridApiRef();

    const getGroppingColumn = () => {
        let grpCol = [];
        if (datagridName === "prHistory") {
            grpCol.push("Banfn");
        } else if (datagridName === "poHistory") {
            grpCol.push("Ebeln");
        }
        return grpCol;
    };

    const initialState = useKeepGroupedColumnsHidden({
        apiRef: customApiRef,
        initialState: {
            rowGrouping: {
                model: getGroppingColumn(),
            },
        },
    });

    return (
        <Box sx={{
            boxShadow: 3,
            borderRadius: 1,
            backgroundColor: '#fff',
        }} >
            <StripedDataGrid
                pagination={pagination}
                hideFooter={!pagination}
                showToolbar={showToolbar}
                rows={rows}
                columns={columns}
                autoHeight
                density={density || "compact"}
                getRowId={(row) =>
                    datagridName === "EstimatedColumn" ? row?.id : Math?.random()
                }
                apiRef={customApiRef}
                initialState={initialState}
                label={label}
                getRowClassName={(params) => {
                    const classes = [];
                    if (params.row.isTotalRow) {
                        classes.push('total-row');
                    }
                    classes.push(params.indexRelativeToCurrentPage % 2 === 0 ? 'odd' : 'even');
                    if (externalGetRowClassName) {
                        const extra = externalGetRowClassName(params);
                        if (extra) classes.push(extra);
                    }
                    return classes.join(' ');
                }}
                sx={{
                    "& .css-ckj3ov-MuiDataGrid-toolbarLabel": {
                        fontWeight: "700",
                        fontSize: "20px"
                    },
                    "& .css-53g0n7-MuiButtonBase-root-MuiIconButton-root": {
                        color: "#005AA6"
                    },
                    "& .css-1gxrdpv-MuiButtonBase-root-MuiIconButton-root-MuiDataGrid-toolbarQuickFilterTrigger": {
                        color: "#005AA6"
                    },
                    ...externalSx,
                }}
                slots={slots}
                pinnedRows={pinnedRows}
                disableColumnSorting
            />
        </Box>
    );
};

export default MuiDataGrid;
